// @flow

import React from 'react';
import CloseableComponent from './CloseableComponent';

type Option = {
  label: string,
  value: string
}
type Props = {
  handleChange: () => void,
  options: Option[],
  current: string,
}

type State = {
  isOpened: boolean,
}

class SelectComponent extends React.Component<Props, State> {
  state = {
    isOpened: false,
  };

  buttonRef: ?HTMLButtonElement;

  toggleOpen = () => {
    this.setState({
      isOpened: !this.state.isOpened,
    });
  }

  render() {
    return (
      <div className="apollo-select-container">
        <button
          ref={(ref) => {
            if (ref && !this.buttonRef) {
              this.buttonRef = ref;
            }
          }}
          className="apollo-select"
          onClick={this.toggleOpen}
        >
          {this.props.options.filter(option => this.props.current === option.value)[0].label}
          <i className={`fa fa-chevron-right${this.state.isOpened ? ' opened' : ''}`} />
        </button>

        <CloseableComponent
          isOpened={this.state.isOpened}
          toggle={this.toggleOpen}
          buttonRef={this.buttonRef}
        >
          <div
            className={`apollo-select-array-container${this.state.isOpened ? '' : ' apollo-select-array-container--closed'}`}
          >
            <div
              role="presentation"
              className="apollo-select-array"
            >
              {
                this.props.options.map(option => (
                  <button
                    className={`apollo-select-value${this.props.current === option.value ? ' apollo-select-value--selected' : ''}`}
                    key={option.label}
                    onClick={() => {
                        this.toggleOpen();
                        this.props.handleChange(option.value);
                      }}
                    disabled={this.props.current === option.value}
                  >
                    {option.label}
                  </button>
                  ))
              }
            </div>
          </div>
        </CloseableComponent>
      </div>
    );
  }
}

export default SelectComponent;
